import * as React from 'react';
import { ButtonHTMLAttributes, useEffect, useState } from 'react';
import icon_close_dark from './icon_close_dark.svg';
import icon_link from 'images/product/link_icon.svg';

export type IconBtnType = 'close' | 'link';
type Props = {
  btnType: IconBtnType;
  show?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const IconBtn = ({ btnType, show = true, ...rest }: Props) => {
  const [src, setSrc] = useState<string>('');
  useEffect(() => {
    if (btnType === 'close') {
      setSrc(icon_close_dark);
    }
    if (btnType === 'link') {
      setSrc(icon_link);
    }
  }, [btnType]);
  if (!show) return null;
  return (
    <button {...rest}>
      <img src={src} alt="icon" />
    </button>
  );
};
